<template>
  <v-flex :class="$style.ordersListItem"
          xs12
          @click="emitSavingToCart">
    <div :class="$style.orderImage">
      <img v-if="orderImage"
           :src="orderImage"
           :class="$style.orderIcon">
    </div>
    <div :class="$style.orderInfo">
      <h6 :class="$style.orderTitle">{{ order.title }}</h6>
      <h6 :class="$style.orderPrice">{{ orderPrice | toPrice }}</h6>
      <p :class="$style.orderDate">{{ orderDate }}</p>
    </div>

    <div :class="$style.orderRightImage">
      <svg v-svg
           :class="$style.chevronRight"
           symbol="chevron-left"/>
    </div>
  </v-flex>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import moment from 'moment';
import helpers from '@/lib/helpers';

/**
 * Renders order data in previous order navigation drawer.
 */
@Component({
  name:  'Order',
  props: {
    order: Object,
  },
})
export default class Order extends Vue {
  get orderImage() {
    if (this.order.image) {
      return helpers.getImagePath(this.order.image);
    }

    return '';
  }

  get orderDate() {
    return moment(this.order.date).format('MMM DD, YYYY');
  }

  get orderPrice() {
    return Number(this.order.price, 10);
  }

  emitSavingToCart() {
    this.$emit('save-to-cart', this.order);
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";

  $orderImageWidth: 83px;
  $orderRightImageWidth: 24px;

  $orderImageWidthMiddle: 230px;
  $orderRightImageWidthMiddle: 80px;

  .ordersListItem {
    display: flex;
    align-items: center;
    background-color: $white;
    box-shadow: 0 1px 2px 0 rgba(125,125,125,0.37);
    margin-bottom: 6px;
    overflow-y: auto;
    cursor: pointer;
    .orderImage {
      width: $orderImageWidth;
      padding-left: 20px;
    }
    .orderRightImage {
      width: $orderRightImageWidth;
      padding-right: 16px;
    }
  }

  .orderInfo {
    width: calc(100% - #{$orderImageWidth + $orderRightImageWidth});
    padding: 13px 13px 17px;
    .orderTitle {
      margin-bottom: 2px;
    }
    .orderPrice {
      font-weight: 300;
      margin-bottom: 5px;
    }
    .orderDate {
      color: $black-semi-transparent;
      font-size: 12px;
      font-style: italic;
      line-height: 15px;
    }
  }

  .orderIcon {
    width: 60px;
  }

  .chevronRight {
    fill: $black;
    transform: rotateY(180deg);
    width: 8px;
    height: 13px;
  }

  @media screen and (max-width: $kiosk-breakpoint-max) {
    .ordersListItem {
      margin-bottom: 16px;
      .orderImage {
        width: $orderImageWidthMiddle;
        padding: 0 100px;
      }
      .orderRightImage {
        width: $orderRightImageWidthMiddle;
        padding-right: 50px;
      }
    }

    .orderInfo {
      padding: 47px 66px 33px;
      width: calc(100% -
        #{$orderImageWidthMiddle + $orderRightImageWidthMiddle}
      );
      .orderTitle,
      .orderPrice {
        font-size: 34px;
        line-height: 48px;
      }
      .orderPrice {
        margin-bottom: 19px;
      }
      .orderDate {
        font-size: 26px;
        line-height: 33px;
      }
    }

    .orderIcon {
      width: 112px;
      height: 75px;
    }

    .chevronRight {
      width: 30px;
      height: 40px;
    }

  }

  @media screen and (max-width: 960px) {
    .ordersListItem {
      margin-bottom: 6px;
      .orderImage {
        width: $orderImageWidth;
        padding-left: 25px;
        padding-right: 0;
      }
      .orderRightImage {
        width: $orderRightImageWidth;
        padding-right: 16px;
      }
    }

    .orderInfo {
      width: calc(100% - #{$orderImageWidth + $orderRightImageWidth});
      padding: 13px 13px 17px;
      .orderTitle {
        font-size: 15px;
        line-height: 20px;
      }
      .orderPrice {
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 5px;
      }
      .orderDate {
        font-size: 12px;
        line-height: 15px;
      }
    }

    .orderIcon {
      width: 52px;
      height: 35px;
    }

    .chevronRight {
      width: 8px;
      height: 13px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/cart/components/Order.vue